import React from 'react';
import { cn } from '../../lib/cn';
import type { IconKind } from '../Icon/Icon';
import { PatientProfileChip } from './PatientProfileChip';

export interface PatientProfileSectionCardProps {
  icon: IconKind;
  title: string;
  accent?: string;
  subtitle?: string;
  right?: React.ReactNode;
  bodyPad?: string;
  children: React.ReactNode;
  className?: string;
}

export function PatientProfileSectionCard({
  icon,
  title,
  accent = 'var(--ai-3)',
  subtitle,
  right,
  bodyPad = 'px-[18px] py-[14px]',
  children,
  className,
}: PatientProfileSectionCardProps) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-[var(--r-xl)] border border-[var(--cream-2)] border-l-[3px] bg-[var(--cream-1)] shadow-[var(--sh-1)]',
        className,
      )}
      style={{ borderLeftColor: accent }}
    >
      <div className="flex items-center gap-[11px] border-b border-[var(--cream-2)] bg-[var(--cream-0)] px-[18px] py-[13px]">
        <PatientProfileChip icon={icon} accent={accent} size={28} />
        <div className="min-w-0">
          <div className="font-[var(--font-display)] text-[15.5px] font-semibold tracking-[-0.015em] text-[var(--ink-0)]">
            {title}
          </div>
          {subtitle ? (
            <div className="mt-px text-[11.5px] text-[var(--ink-3)]">{subtitle}</div>
          ) : null}
        </div>
        {right ? <span className="ml-auto">{right}</span> : null}
      </div>
      <div className={bodyPad}>{children}</div>
    </div>
  );
}
